import React, { FC } from 'react';
import { BoardInner } from './board-inner';
import { BoardStateProvider } from './context';
import type { BoardProps } from './types';

export const Board: FC<BoardProps> = (props) => {
  return (
    <BoardStateProvider {...props}>
      <BoardInner {...props} />
    </BoardStateProvider>
  );
};
